import React from 'react';
import {
  AboutBaby,
  BabyImage,
  BabyNameContent,
  BabyNameTitle,
  BannerContainer,
  LeftSection,
  RightSection,
} from './styled';

export default function BabyNameTopBanner() {
  return (
    <BannerContainer>
      <LeftSection></LeftSection>
      <RightSection></RightSection>
      <AboutBaby>
        <BabyImage src="/images/babynamebannerimage.png" alt="Baby Banner" />
        <div>
          <BabyNameTitle>Baby Name Finder</BabyNameTitle>
          <BabyNameContent>
            Our name gives us a unique identity & is the very foundation of our
            being. Therefore, it is very important, as parents, to put in some
            time & effort in finding the best name for your child. After all,
            this is what you&apos;re going to be calling every now & then. Use
            Mylo Baby Name Finder to choose the best option from a collection of
            baby names to help you make the decision.
          </BabyNameContent>
        </div>
      </AboutBaby>

      {/* <BannerWave src="/images/babynamebannerwave.png" alt="" /> */}
    </BannerContainer>
  );
}
